module.exports = __webpack_public_path__ + "img/lavande_papillon.6f3bff7d.jpg";